import React from "react";
import i18n from "@/lang/i18n";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import SuccessErrorScreen from "@/components/custom/SuccessErrorScreen";

const DriverCheckInSuccess: React.FC = () => {
  const driverDetails = useSelector(
    (state: RootState) => state.driverDetails.details?.data
  );
  const vrn = driverDetails?.allotment_details?.car_details?.vrn || "";

  return (
    <SuccessErrorScreen message={`${vrn} ${i18n.t("driver_check_in_success")}`} type={1} homeButtonText={"Go To Homescreen"} />
  );
};

export default DriverCheckInSuccess;
